// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(25vw, 1fr));
  gap: 1rem;
  padding: 1rem;
  width: 80vw;
  margin-top: 3vh;
  margin-bottom: 0;
  align-items: center;
  justify-items: center;
}

.analytics-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.analytics-figure {
  width: 150px;
  height: 150px;
  margin-bottom: 0.5rem;
}

.analytics-title {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.25rem;
}

.analytics-value {
  font-size: 2.5rem;
  font-weight: bold;
  color: #111;
  margin-bottom: 0.25rem;
}

.analytics-desc {
  font-size: 1.5rem;
  color: #666;
}

@media (max-width: 991px) {
  .analytics-container {
    width: 85vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminAnalytics.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".analytics-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(25vw, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n  width: 80vw;\n  margin-top: 3vh;\n  margin-bottom: 0;\n  align-items: center;\n  justify-items: center;\n}\n\n.analytics-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.analytics-figure {\n  width: 150px;\n  height: 150px;\n  margin-bottom: 0.5rem;\n}\n\n.analytics-title {\n  font-size: 1.5rem;\n  color: #333;\n  margin-bottom: 0.25rem;\n}\n\n.analytics-value {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: #111;\n  margin-bottom: 0.25rem;\n}\n\n.analytics-desc {\n  font-size: 1.5rem;\n  color: #666;\n}\n\n@media (max-width: 991px) {\n  .analytics-container {\n    width: 85vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
